import { Component, HostListener, OnInit } from '@angular/core';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {

  showChat:boolean = false;
  showChatWindow = false;
  openSettingSidebar: boolean = false


  // getChatOpen(message:boolean){
  //   this.showChat = message;
  // }
  // getChatclose(message:boolean){
  //   this.showChat = message;
  // }
  // getopenChatWindow(message:boolean){
  //   this.showChatWindow = message;
  // }

  
  constructor() { }

  ngOnInit(): void {
  }

  isNavbarFixed: boolean = false;

  @HostListener('window:scroll', ['$event']) onScroll() {
    var divScroll = document.querySelector('.settingtab').scrollTop;
    if (divScroll > 280) {
      this.isNavbarFixed = true;
      //document.querySelector('.head').classList.add('fixHeader');
    } else {
      this.isNavbarFixed = false;
      //document.querySelector('.head').classList.remove('fixHeader')
    }
  }


}
